import { render, staticRenderFns } from "./SiteAbout.vue?vue&type=template&id=492c961a&scoped=true"
var script = {}
import style0 from "./SiteAbout.vue?vue&type=style&index=0&id=492c961a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c961a",
  null
  
)

export default component.exports